import {
  fetchRegionalDistrictsGetByLocationId,
  IRegionalDistrictsGetByLocationIdRequest,
  TRegionalDistrictsGetByLocationIdResponse,
} from 'shared/repositories/geo/v1/regional-districts/get-by-location-id';

import { IApplicationContext } from '../../types/applicationContext';
import { IRegionalDistrict } from 'shared/types/geo';

export const fetchRegionalDistrictsByLocation = async (
  { httpApi }: IApplicationContext,
  parameters: IRegionalDistrictsGetByLocationIdRequest,
): Promise<IRegionalDistrict[]> => {
  const { response }: TRegionalDistrictsGetByLocationIdResponse = await fetchRegionalDistrictsGetByLocationId({
    httpApi,
    parameters,
  });

  return response.districts;
};

export async function fetchRegionalDistrictsByLocationSafe(
  context: IApplicationContext,
  parameters: IRegionalDistrictsGetByLocationIdRequest,
): Promise<IRegionalDistrict[]> {
  try {
    return await fetchRegionalDistrictsByLocation(context, parameters);
  } catch (ex) {
    context.logger.warning(ex, {
      degradation: 'Запрос областных районов по id',
      details: {
        microserviceName: 'geo',
        pathApi: '/public/v1/regional-districts/get-by-location-id/',
        parameters: JSON.stringify(parameters),
      },
    });

    return [];
  }
}
